<div class="address1 address-part">{{ address.address1 }}</div>
<div class="address2 address-part">{{ address.address2 }}</div>
<div class="address3 address-part">
  <span class="city">{{ address.city }} </span>
  <span class="province-code">{{ province }}</span>
  <span class="postal-code">{{ address.postalCode }}</span>
</div>
<div class="country address-part">{{ country }}</div>
